import { gql } from '@apollo/client';

export const CREATE_DRIVER_LEARNING_CENTER_FAQ_CATEGORY = gql`
  mutation CreateDriverLearningCenterFaqCategory($input: CreateFaqCategoryInput!) {
    createDriverLearningCenterFaqCategory(input: $input)
  }
`;

export const UPDATE_DRIVER_LEARNING_CENTER_FAQ_CATEGORY = gql`
  mutation UpdateDriverLearningCenterFaqCategory($id: ID!, $input: UpdateFaqCategoryInput!) {
    updateDriverLearningCenterFaqCategory(id: $id, input: $input)
  }
`;

export const DELETE_DRIVER_LEARNING_CENTER_FAQ_CATEGORY = gql`
  mutation DeleteDriverLearningCenterFaqCategory($id: ID!) {
    deleteDriverLearningCenterFaqCategory(id: $id)
  }
`;

export const CREATE_DRIVER_LEARNING_CENTER_FAQ_ARTICLE = gql`
  mutation CreateDriverLearningCenterFaqArticle($input: CreateFaqArticleInput!) {
    createDriverLearningCenterFaqArticle(input: $input)
  }
`;

export const UPDATE_DRIVER_LEARNING_CENTER_FAQ_ARTICLE = gql`
  mutation UpdateDriverLearningCenterFaqArticle($id: ID!, $input: UpdateFaqArticleInput!) {
    updateDriverLearningCenterFaqArticle(id: $id, input: $input)
  }
`;

export const DELETE_DRIVER_LEARNING_CENTER_FAQ_ARTICLE = gql`
  mutation DeleteDriverLearningCenterFaqArticle($id: ID!) {
    deleteDriverLearningCenterFaqArticle(id: $id)
  }
`;

export const TOGGLE_DRIVER_LEARNING_CENTER_FAQ_NODE_ENABLED = gql`
  mutation ToggleDriverLearningCenterFaqNodeEnabled($id: ID!, $isEnabled: Boolean!) {
    toggleDriverLearningCenterFaqNodeEnabled(id: $id, isEnabled: $isEnabled)
  }
`;
